import Field from './Field';
import withMediaQueries from '../../../hocs/withMediaQueries';

export default withMediaQueries(Field);




// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/index.js